import { render, staticRenderFns } from "./listaDepositos.vue?vue&type=template&id=394668cd&"
import script from "./listaDepositos.vue?vue&type=script&lang=js&"
export * from "./listaDepositos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports